import React from 'react'

interface Props {
  pageIndex: number
  pageOptions: any
  previousPage: () => void
  canPreviousPage: boolean
  nextPage: () => void
  canNextPage: boolean
}

const FWOTablePagination = (props: Props) => {
  return (
    <div className="sixteen wide">
      <div className="item">
        <button
          type="button"
          className="ui labeled icon button is-secondary"
          onClick={props.previousPage}
          disabled={!props.canPreviousPage}
        >
          <i className="left chevron icon"></i>
          Previous
        </button>
        <div className="ui label pagination-label">
          {props.pageIndex + 1} out of {props.pageOptions.length}
        </div>
        &nbsp; &nbsp;
        <button
          type="button"
          className="ui labeled icon button is-secondary"
          onClick={props.nextPage}
          disabled={!props.canNextPage}
        >
          Next
          <i className="right chevron icon"></i>
        </button>
      </div>
    </div>
  )
}

export default FWOTablePagination
